/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiWebListysankcyjneZmianyGet$Params {
  d?: number;
  u?: string;
}

export function apiWebListysankcyjneZmianyGet(http: HttpClient, rootUrl: string, params?: ApiWebListysankcyjneZmianyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiWebListysankcyjneZmianyGet.PATH, 'get');
  if (params) {
    rb.query('d', params.d, {});
    rb.query('u', params.u, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiWebListysankcyjneZmianyGet.PATH = '/api/web/listysankcyjne/zmiany';
